import { Icon, ProgressBar } from '@openedx/paragon';
import { RiGraduationCapLine } from '@remixicon/react';

const OngoingCourseCard = ({
  title,
  progressPercent,
  badgeText,
  imageUrl,
  badgeIconSrc,
  homeUrl,
}) => {
  const content = (
    <>
      <div
        className="ongoing-course-card__image"
        style={{ backgroundImage: `url(${imageUrl})` }}
        role="img"
        aria-label={title}
      >
        <div className="ongoing-course-card__imageBadge">
          <Icon
            className="ongoing-course-card__imageBadgeIcon"
            src={badgeIconSrc || RiGraduationCapLine}
            size="xs"
          />
          <span className="ongoing-course-card__imageBadgeText">{badgeText}</span>
        </div>
      </div>

      <div className="ongoing-course-card__details">
        <div className="ongoing-course-card__title">{title}</div>
        <ProgressBar
          now={progressPercent}
          label={`${progressPercent}%`}
          srOnly
          variant="success"
          size="sm"
          className="ongoing-course-card__progressBar"
        />
      </div>
    </>
  );

  if (homeUrl) {
    return (
      <a className="ongoing-course-card" href={homeUrl}>
        {content}
      </a>
    );
  }

  return <div className="ongoing-course-card">{content}</div>;
};

export default OngoingCourseCard;

